module.exports = __webpack_public_path__ + "static/img/result_404.007be279.png";